import React, { useState, useEffect , useContext} from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { customFilter } from 'react-bootstrap-table2-filter';
import { LabelText } from '../../../components/Language';
import NumberFormat from 'react-number-format';
import { isNullOrUndefined } from 'util';
import {LanguageContext} from '../../../containers/Language/LanguageProvider';
import Sort from '../../../components/UI/Sort/Sort';
import { OverviewContext } from '../../context/OverviewProvider';
import FilterOverlayTrigger from '../../../components/UI/Filter/FilterOverlayTrigger';
import OverviewDetailFooter from '../../../NmbsUser/components/OverviewDetailFooter/OverviewDetailFooter'
import {parse} from 'date-fns';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import config from '../../../common/const/config';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReceipt, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { getTwoDigitMonth, getYear } from '../../../common/utility/utility';
import {changeRequestTooltip} from '../../../components/UI/Tooltip/Tooltip';
import CustomOverlayTrigger from '../../../hoc/CustomOverlayTrigger';
import '../../../components/UI/Sort/Sort.css';
import './index.css';

export default function OverviewDetails(props) {
    const [overviewDetails, setOverviewDetailsData] = useState();
    const [error, setError] = useState("");
    const [sortOrder, setSortOrder] = useState(undefined);
    const languageContext = useContext(LanguageContext);
    const { handlerOnClearFilterClick, isClearFilter,  selectedRevenueId,
        handlerCheckDetailsFilterApplied, setDataErrorHandler, dataError } = useContext(OverviewContext);
    const [filterData, setFilterData] = useState([]);
    const [columnFilterIndexes, setColumnFilterIndexes]=useState([]);
    const [columnFilterOptions, setColumnFilterOptions]=useState(new Map());
    const maxvalue = config.maxfieldvalue;  
    
    let data = overviewDetails && overviewDetails.nmbsUserDetailOverviewDtos &&
            overviewDetails.nmbsUserDetailOverviewDtos.length > 0 ? overviewDetails.nmbsUserDetailOverviewDtos : [];
    let revenueAmountData = overviewDetails && overviewDetails.revenueAmountDetailsDto;   

    useEffect(() => {
        let overviewDetailsData = props.overviewDetails;
        if (props.overviewDetails && props.overviewDetails.nmbsUserDetailOverviewDtos) {
            overviewDetailsData.nmbsUserDetailOverviewDtos = InitialFormatNMBSDetails(props.overviewDetails.nmbsUserDetailOverviewDtos);
        }
        if (props.overviewDetails && props.overviewDetails.revenueAmountDetailsDto) {
            overviewDetailsData.revenueAmountDetailsDto = InitialFormatRevenueAmount(props.overviewDetails.revenueAmountDetailsDto);
            let totalSoldTickets = props.overviewDetails.revenueAmountDetailsDto.totalSoldTickets;
            overviewDetailsData.revenueAmountDetailsDto.totalSoldTickets = (isNullOrUndefined(totalSoldTickets)|| totalSoldTickets === -1) ? "" : totalSoldTickets.toLocaleString('nl-BE').replace(/\s/g, ".")
        }
        setOverviewDetailsData(overviewDetailsData);
        dataError && dataError.size === 0 ? setError("") : (error === ""?
        setError(Array.from(dataError)[dataError.size-1][1]): setError(error))
        updateFilterData();   
        updateFileFilterData();  
    }, [props.overviewDetails]);

    useEffect(() => {
        let header = document.querySelectorAll(".OverviewDetails-datatable thead th" );
         if(header && header.length > 0 )
         {
             header.forEach(element => {
                 element.setAttribute("tabindex", "-1");
             });
         }
     }, []);  

     useEffect(() => {
        if(dataError && dataError.size === 0)
        {
            setError("");
        }
     }, [dataError]);      

    const sortHandler = (order, column, isEditableColumn) => { 
       if(order && column && isEditableColumn === true)
         {
          const a = order.split(",");
          order = a[1] !== column.dataField? undefined : a[0];
         }         
         return (<Sort order= {order}/>)           
    }

    const getFormattedRuleData = (row, fieldName) => {
        return (
            <div>
                {
                    fieldName == 'billingRule' ?
                        <span><LabelText tid={row.billingRule} /></span>
                        : <span><LabelText tid={row.conditionRule} /></span>
                }
            </div>
        )
    }

    const updateFilterData = () => {      
        if(filterData && filterData.length > 0 && props.overviewDetails && 
            props.overviewDetails.nmbsUserDetailOverviewDtos &&
            props.overviewDetails.nmbsUserDetailOverviewDtos.length > 0) {             
            let filterDtlData = filterData.map(d=> {                                 
                const revenueDtl = props.overviewDetails.nmbsUserDetailOverviewDtos.find(f=>f.revenueId === d.revenueId);
                return revenueDtl ?  {...revenueDtl } : {...d}
            });

            if(filterDtlData && filterDtlData.length > 0) {
                setFilterData(filterDtlData);
            }                    
        }   
    }

    const updateFileFilterData = () => { 
        if(selectedRevenueId && props.overviewDetails && props.overviewDetails.nmbsUserDetailOverviewDtos &&
            props.overviewDetails.nmbsUserDetailOverviewDtos.length > 0) { 
        const fileRowDtl = props.overviewDetails.nmbsUserDetailOverviewDtos.find(f=> f.revenueId === selectedRevenueId);
        if(fileRowDtl)
            {   let filterFileDtlData = filterData.map(d => (fileRowDtl.contractCode === d.contractCode && (getTwoDigitMonth(fileRowDtl.revenueDate) 
                + getYear(fileRowDtl.revenueDate) === getTwoDigitMonth(d.revenueDate) + getYear(d.revenueDate))) ? 
                { ...d, userCashRegisterFileName: fileRowDtl.userCashRegisterFileName } : {...d});

                if(filterFileDtlData && filterFileDtlData.length > 0) {
                    setFilterData(filterFileDtlData);
                }  
            }
        }
    }

    function getTotalWithoutVatValueFooter(withoutVatTotaldata) {
        let total = null;
        let value = isNaN(withoutVatTotaldata["withoutVatTax_0"]) ? ((withoutVatTotaldata["withoutVatTax_0"].replace(/\s/g, ".")).replace(/\./g, "")).replace(/\,/g, ".") : withoutVatTotaldata["withoutVatTax_0"];
        let tax_0 = isNaN(value) ? value && value.trim() !== "" && Number(value) : value;
        value = isNaN(withoutVatTotaldata["withoutVatTax_6"]) ? ((withoutVatTotaldata["withoutVatTax_6"].replace(/\s/g, ".")).replace(/\./g, "")).replace(/\,/g, ".") : withoutVatTotaldata["withoutVatTax_6"];
        let tax_6 = isNaN(value) ? value && value.trim() !== "" && Number(value) : value;
        value = isNaN(withoutVatTotaldata["withoutVatTax_12"]) ? ((withoutVatTotaldata["withoutVatTax_12"].replace(/\s/g, ".")).replace(/\./g, "")).replace(/\,/g, ".") : withoutVatTotaldata["withoutVatTax_12"]
        let tax_12 = isNaN(value) ? value && value.trim() !== "" && Number(value) : value;
        value = isNaN(withoutVatTotaldata["withoutVatTax_21"]) ? ((withoutVatTotaldata["withoutVatTax_21"].replace(/\s/g, ".")).replace(/\./g, "")).replace(/\,/g, ".") : withoutVatTotaldata["withoutVatTax_21"]
        let tax_21 = isNaN(value) ? value && value.trim() !== "" && Number(value) : value;
        total = Number(tax_0) + Number(tax_6) + Number(tax_12) + Number(tax_21);
        return total;
    }

    function getTotalWithVatValueFooter(withVatTotaldata) {
        let total = null;
        let value = isNaN(withVatTotaldata["withVatTax_0"]) ? ((withVatTotaldata["withVatTax_0"].replace(/\s/g, ".")).replace(/\./g, "")).replace(/\,/g, ".") : withVatTotaldata["withVatTax_0"];
        let tax_0 = isNaN(value) ? value && value.trim() !== "" && Number(value) : value;
        value = isNaN(withVatTotaldata["withVatTax_6"]) ? ((withVatTotaldata["withVatTax_6"].replace(/\s/g, ".")).replace(/\./g, "")).replace(/\,/g, ".") : withVatTotaldata["withVatTax_6"];
        let tax_6 = isNaN(value) ? value && value.trim() !== "" && Number(value) : value;
        value = isNaN(withVatTotaldata["withVatTax_12"]) ? ((withVatTotaldata["withVatTax_12"].replace(/\s/g, ".")).replace(/\./g, "")).replace(/\,/g, ".") : withVatTotaldata["withVatTax_12"]
        let tax_12 = isNaN(value) ? value && value.trim() !== "" && Number(value) : value;
        value = isNaN(withVatTotaldata["withVatTax_21"]) ? ((withVatTotaldata["withVatTax_21"].replace(/\s/g, ".")).replace(/\./g, "")).replace(/\,/g, ".") : withVatTotaldata["withVatTax_21"]
        let tax_21 = isNaN(value) ? value && value.trim() !== "" && Number(value) : value;
        total = Number(tax_0) + Number(tax_6) + Number(tax_12) + Number(tax_21);
        return total;
    }

    function InitialFormatRevenueAmount(revData) {
        if (revData) {
            return {
                ...revData,
                withVatTax_0: (revData.withVatTax_0 === 0) ? "0,00" : (revData.withVatTax_0).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),
                withVatTax_6: (revData.withVatTax_6 === 0) ? "0,00" : (revData.withVatTax_6).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),
                withVatTax_12: (revData.withVatTax_12 === 0) ? "0,00" : (revData.withVatTax_12).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),
                withVatTax_21: (revData.withVatTax_21 === 0) ? "0,00" : (revData.withVatTax_21).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),
                withoutVatTax_0: (revData.withoutVatTax_0 === 0) ? "0,00" : (revData.withoutVatTax_0).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),
                withoutVatTax_6: (revData.withoutVatTax_6 === 0) ? "0,00" : (revData.withoutVatTax_6).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),
                withoutVatTax_12: (revData.withoutVatTax_12 === 0) ? "0,00" : (revData.withoutVatTax_12).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),
                withoutVatTax_21: (revData.withoutVatTax_21 === 0) ? "0,00" : (revData.withoutVatTax_21).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),                
                // totalValueWithVat :  (revData.totalValueWithVat === 0 ) ? "0,00": (revData.totalValueWithVat).toLocaleString('nl-BE', {minimumFractionDigits: 2, maximumFractionDigits: 2}),
                // totalValueWithoutVat :  (revData.totalValueWithoutVat === 0 ) ? "0,00": (revData.totalValueWithoutVat).toLocaleString('nl-BE', {minimumFractionDigits: 2, maximumFractionDigits: 2}),
                totalValueWithVat: (revData.totalValueWithVat === 0) ? "0,00" : getTotalWithVatValueFooter(revData).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),
                totalValueWithoutVat: (revData.totalValueWithoutVat === 0) ? "0,00" : getTotalWithoutVatValueFooter(revData).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),                            
            }
        }
        return revData;
    }

    function InitialFormatNMBSDetails(nmbsData) {
        if (nmbsData && nmbsData.length > 0) {
            nmbsData = nmbsData.map(d => {
                return {
                    ...d,
                    revenueWithTaxAmount: {
                        ...d.revenueWithTaxAmount,
                        tax_0: (d.revenueWithTaxAmount.tax_0 === 0) ? "0,00" : (d.revenueWithTaxAmount.tax_0).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),
                        tax_6: (d.revenueWithTaxAmount.tax_6 === 0) ? "0,00" : (d.revenueWithTaxAmount.tax_6).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),
                        tax_12: (d.revenueWithTaxAmount.tax_12 === 0) ? "0,00" : (d.revenueWithTaxAmount.tax_12).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),
                        tax_21: (d.revenueWithTaxAmount.tax_21 === 0) ? "0,00" : (d.revenueWithTaxAmount.tax_21).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),
                    },
                    revenueWithoutTaxAmount: {
                        ...d.revenueWithoutTaxAmount,
                        tax_0: (d.revenueWithoutTaxAmount.tax_0 === 0) ? "0,00" : (d.revenueWithoutTaxAmount.tax_0).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),
                        tax_6: (d.revenueWithoutTaxAmount.tax_6 === 0) ? "0,00" : (d.revenueWithoutTaxAmount.tax_6).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),
                        tax_12: (d.revenueWithoutTaxAmount.tax_12 === 0) ? "0,00" : (d.revenueWithoutTaxAmount.tax_12).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),
                        tax_21: (d.revenueWithoutTaxAmount.tax_21 === 0) ? "0,00" : (d.revenueWithoutTaxAmount.tax_21).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),
                    },
                    totalValueWithVat: (d.totalValueWithVat === 0) ? "0,00" : (d.totalValueWithVat).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),
                    totalValueWithoutVat: (d.totalValueWithoutVat === 0) ? "0,00" : (d.totalValueWithoutVat).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, "."),
                    isEditable: props.isEnableEditableFields,
                    remarksOptionValues : getRemarksFilterValue(d.isShopOpen),
                    remarksCode : d.remarksCode,
                    remarksId : d.remarksId,
                    soldTicket: (isNullOrUndefined(d.soldTicket)|| d.soldTicket === -1 ) ? "" : d.soldTicket.toLocaleString('nl-BE').replace(/\s/g, "."),
                    tax_0_IsValid:  !checkIfNullOrUndefined (d.tax_0_IsValid) ? d.tax_0_IsValid : true,
                    tax_6_IsValid: !checkIfNullOrUndefined(d.tax_6_IsValid) ? d.tax_6_IsValid : true,
                    tax_12_IsValid: !checkIfNullOrUndefined(d.tax_12_IsValid) ? d.tax_12_IsValid : true,
                    tax_21_IsValid: !checkIfNullOrUndefined(d.tax_21_IsValid) ? d.tax_21_IsValid : true,
                    soldTicket_IsValid: !checkIfNullOrUndefined(d.soldTicket_IsValid) ? d.soldTicket_IsValid : true,
                    isShopOpen_IsValid: !checkIfNullOrUndefined(d.isShopOpen_IsValid) ? d.isShopOpen_IsValid : true,
                }
            });
        }

        return nmbsData;
    }

    const getRevenueAmtField = (row, fieldName, isTaxAmountColumn, taxColumnName, isWithTaxColumn, isTotalWithTaxColumn) => {
        let totalFooterColumnValues = columnFilterIndexes && columnFilterIndexes.length > 0 &&
                                        filterData && filterData.length > 0 ? 
                                        setRevenueTotalData(revenueAmountData, fieldName, taxColumnName, isTaxAmountColumn,
                                                            isWithTaxColumn, isTotalWithTaxColumn, filterData) 
                                        : revenueAmountData
        return (
            <div>
                {
                    totalFooterColumnValues &&
                    <span>{(totalFooterColumnValues[fieldName])}
                    </span>
                }
            </div>
        )
    }

    const headerFormatterHandler = (cell, isFileColumn, labelText, filterElement) => {  
        return (<div className="header-formatter">
            <span className="column-header-text">
                <LabelText tid={labelText} />          
            </span>
            { isFileColumn? null: sortHandler(sortOrder, cell, true) }
            {filterElement}
            {props.isEditAccess && props.isEnableEditableFields ?
                <div className="edit-icon-container"> 
                    <div>
                     <FontAwesomeIcon className="edit-Icon" icon = {faPencilAlt}/>
                    </div>
                </div> 
                : undefined}
        </div>)
    }

    function applyFieldLevelValidation(row, columnName, isTaxAmountColumn, taxPercentage, fieldExceedingError,areInValidValuesForShopOpenYes) {       
        let fieldLevelError = ""; 
       
        if(fieldExceedingError !== "")
        {
            fieldLevelError = fieldExceedingError;          
            setDataErrorHandler(row.revenueId , fieldExceedingError, true);
        }
        else if(fieldLevelError.trim() === "" && areInValidValuesForShopOpenYes !== "")
        {            
            fieldLevelError = areInValidValuesForShopOpenYes;
            setDataErrorHandler(row.revenueId , fieldLevelError, true);
        }
        else if (!row.tax_0_IsValid || !row.tax_6_IsValid || !row.tax_12_IsValid || !row.tax_21_IsValid 
            || !row.soldTicket_IsValid || !row.isShopOpen_IsValid) 
        {
            fieldLevelError = !row.isShopOpen_IsValid ? "shop_openstatus" : isInvalidValueExistsInRow(row, "fieldexceeding") ? "fieldexceeding" : "validdata";
            setDataErrorHandler(row.revenueId, fieldLevelError, true);
        }
        else
        {
            if(!isInvalidValueExistsInRow(row, ""))
            {
                setDataErrorHandler(row.revenueId, "", false);
            }
        }
        
        if(fieldLevelError.trim() === "") {
            overviewDetails.nmbsUserDetailOverviewDtos.map(d => {
                if (!d.tax_0_IsValid || !d.tax_6_IsValid || !d.tax_12_IsValid || !d.tax_21_IsValid 
                    || !d.soldTicket_IsValid || !row.isShopOpen_IsValid)
                {
                fieldLevelError = !row.isShopOpen_IsValid ? "shop_openstatus" : isInvalidValueExistsInRow(d, "fieldexceeding") ? "fieldexceeding" : "validdata";
                }
            });
        }
        
        (fieldLevelError !== "") ? setError(fieldLevelError) : (dataError && dataError.size > 0) 
        ? setError(Array.from(dataError)[dataError.size-1][1]) : setError("");

        if (fieldLevelError.trim() === "") {
            props.setOverviewRevenueData(row.revenueId, row, columnName, isTaxAmountColumn, taxPercentage);
        }
    }

    function checkDecimalValue(e, row, columnName, isTaxAmountColumn, taxPercentage) {

        const validationField_Suffix = "_IsValid";
        const value = e.target.value;
        let areInValidValuesForShopOpenYes = "";
        if (value!== null && value.trim() !== "") {
            let decimalValue = value.split(",");
            if (decimalValue.length > 1 && decimalValue[1].length !== 2) { 
                setErrorAttributes(e, row, columnName, isTaxAmountColumn, 
                    taxPercentage, "validdata");
                return false;
            } 
            else if(convertToNumber(value) > maxvalue)
            {
                setErrorAttributes(e, row, columnName, isTaxAmountColumn, 
                    taxPercentage, "fieldexceeding");
                return false;
            }
            else { 
               
                if (columnName !== "soldTicket") {
                    let vatValue = value;
                    if (decimalValue.length === 1)
                        vatValue = vatValue + ",00";
                    row.revenueWithTaxAmount[columnName] = vatValue;
                    row.revenueWithoutTaxAmount[columnName] = getWithoutTaxValue(vatValue, taxPercentage)
                        .toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                        .replace(/\s/g, ".");
                }
                else
                   { 
                       row[columnName] = value;
                   }

                e.target.style.border = "0.2vw solid #2B7C2B";
            }
        } else {           
            setErrorAttributes(e, row, columnName, isTaxAmountColumn, 
                taxPercentage, "");  
            return false;
        }
        row[columnName + validationField_Suffix] = true;

        if(!checkIsShopOpenStatusCorrect(row)) {
            areInValidValuesForShopOpenYes = checkAreInValidValuesForShopOpenYes(row, columnName, isTaxAmountColumn, taxPercentage, false);
        } 

        applyFieldLevelValidation(row, columnName, isTaxAmountColumn, taxPercentage, "", areInValidValuesForShopOpenYes);
        return true;
    }

    const setErrorAttributes = (e, row, columnName, isTaxAmountColumn, taxPercentage, errorType) => {   
        const value = e.target.value; 
        e.target.style.border = "0.2vw solid red"; 
        if (columnName !== "soldTicket") 
        {          
            row.revenueWithTaxAmount[columnName] = value;
            row.revenueWithoutTaxAmount[columnName] = value;
        }
        else
        {
            row[columnName] = value; 
        }  
        row[columnName + "_IsValid"] = false;
        applyFieldLevelValidation(row, columnName, isTaxAmountColumn,taxPercentage, errorType);  
    } 

    
    const setBorder = (columnName, revenueId, className, isAdd) => {
        const id = "#" + columnName + "_" + revenueId;      
        let idSelector = document.querySelector(id);
        if(idSelector && idSelector.classList) {
            isAdd ? idSelector.classList.add(className) : idSelector.classList.remove(className)
        }
    }

    const checkIsShopOpenStatusCorrect = (row) => {   

        if (row.isShopOpen === "No" && row.revenueWithTaxAmount && (checkIfAmountIsZero(row.revenueWithTaxAmount.tax_0) || checkIfAmountIsZero(row.revenueWithTaxAmount.tax_6) ||
            checkIfAmountIsZero(row.revenueWithTaxAmount.tax_12) || checkIfAmountIsZero(row.revenueWithTaxAmount.tax_21) || 
            (row.soldTicket !== "0" && row.soldTicket !== 0))) { 
                if(error && (error.trim() === "soldticketvalidation1" || error.trim() === "soldticketvalidation2")) {
                    setError("shop_openstatus");
                }
                setBorder("isShopOpen", row.revenueId, "highlight-field", true);
                row.isShopOpen_IsValid = false;
                setDataErrorHandler(row.revenueId, "shop_openstatus" , true);                
                return true;
        } 
        else {            
            setBorder("isShopOpen", row.revenueId, "highlight-field", false);
            row.isShopOpen_IsValid = true;
            setDataErrorHandler(row.revenueId, "" , false);
            setError(null);
            return false;
        }
    }


    const checkIfNullOrUndefined = (fieldValue) => {
        return fieldValue === undefined || fieldValue === null || fieldValue === "";
    }

    const checkIfAmountIsZero = (amountValue) => {
        return amountValue!=="" && amountValue !== "0" && amountValue !== "0,00"
    }

    const checkAreInValidValuesForShopOpenYes = (row, columnName, isTaxAmountColumn, taxPercentage, isSubmit) => {
        let isError = false;
        let errMsg = ""
        if (row.revenueWithTaxAmount && (checkIfAmountIsZero(row.revenueWithTaxAmount.tax_0) || checkIfAmountIsZero(row.revenueWithTaxAmount.tax_6) ||
                checkIfAmountIsZero(row.revenueWithTaxAmount.tax_12) || checkIfAmountIsZero(row.revenueWithTaxAmount.tax_21)) && 
                (row.soldTicket === "0" || row.soldTicket === 0)) { 
            isError = true;
            errMsg="soldticketvalidation1";
        } else if (row.revenueWithTaxAmount && (!checkIfNullOrUndefined(row.revenueWithTaxAmount.tax_0) && 
                    !checkIfNullOrUndefined(row.revenueWithTaxAmount.tax_6) &&
                    !checkIfNullOrUndefined(row.revenueWithTaxAmount.tax_12) && 
                    !checkIfNullOrUndefined(row.revenueWithTaxAmount.tax_21) &&
                    !checkIfAmountIsZero(row.revenueWithTaxAmount.tax_0) && 
                    !checkIfAmountIsZero(row.revenueWithTaxAmount.tax_6) &&
                    !checkIfAmountIsZero(row.revenueWithTaxAmount.tax_12) && 
                    !checkIfAmountIsZero(row.revenueWithTaxAmount.tax_21)) && 
                    (row.soldTicket !== "0" && row.soldTicket !== 0)) { 
            errMsg="soldticketvalidation2";
            isError = true;  
        }

        if(errMsg != "") {
            setError(errMsg);
        } 
        else
        { 
            setError(null)
        }

        if(isError){                      
            row.soldTicket_IsValid = false;
            setDataErrorHandler(row.revenueId, errMsg , true);
            setBorder("soldTicket", row.revenueId, "highlight-field", true);
        } 
        else {
            row.soldTicket_IsValid = true;
            setDataErrorHandler(row.revenueId, "" , false);
            setBorder("soldTicket", row.revenueId, "highlight-field", false);          
        }

        props.setOverviewRevenueData(row.revenueId, row, columnName, isTaxAmountColumn, taxPercentage);
        return errMsg;
    } 

    const isMoreThanMaxValue = (maxValueField) => {               
       return maxValueField && convertToNumber(maxValueField) > maxvalue ;      
    } 

    const isInvalidDecimal = (value) => {
        let decimalValue = value.split(",");
        return decimalValue.length > 1 && decimalValue[1].length !== 2 ? true : false
    }

    const isInvalidValueExistsInRow = (rowToCheck, checkType) => {  
        if(checkType === "fieldexceeding")
        {
            return isMoreThanMaxValue(rowToCheck.revenueWithoutTaxAmount.tax_0) ||
            isMoreThanMaxValue(rowToCheck.revenueWithoutTaxAmount.tax_6) ||
            isMoreThanMaxValue(rowToCheck.revenueWithoutTaxAmount.tax_12) ||
            isMoreThanMaxValue(rowToCheck.revenueWithoutTaxAmount.tax_21) ||
            isMoreThanMaxValue(rowToCheck.soldTicket) 
        }  
        else if(checkType === "validdata")   
        {
            return isInvalidDecimal(rowToCheck.revenueWithoutTaxAmount.tax_0) ||
            isInvalidDecimal(rowToCheck.revenueWithoutTaxAmount.tax_6) ||
            isInvalidDecimal(rowToCheck.revenueWithoutTaxAmount.tax_12) ||
            isInvalidDecimal(rowToCheck.revenueWithoutTaxAmount.tax_21) ||
            isInvalidDecimal(rowToCheck.soldTicket) 
        } 
        else
        {     
            return isMoreThanMaxValue(rowToCheck.revenueWithoutTaxAmount.tax_0) || isInvalidDecimal(rowToCheck.revenueWithoutTaxAmount.tax_0) ||
            isMoreThanMaxValue(rowToCheck.revenueWithoutTaxAmount.tax_6) || isInvalidDecimal(rowToCheck.revenueWithoutTaxAmount.tax_6) ||
            isMoreThanMaxValue(rowToCheck.revenueWithoutTaxAmount.tax_12) || isInvalidDecimal(rowToCheck.revenueWithoutTaxAmount.tax_12) ||
            isMoreThanMaxValue(rowToCheck.revenueWithoutTaxAmount.tax_21) || isInvalidDecimal(rowToCheck.revenueWithoutTaxAmount.tax_21) ||
            isMoreThanMaxValue(rowToCheck.soldTicket) || isInvalidDecimal(rowToCheck.soldTicket) 
        }
    } 

    function getWithoutTaxValue(withoutTaxData, taxPercentage) {
        let amt = null;
        let value = (withoutTaxData.replace(/\./g, "")).replace(/\,/g, ".");
        amt = Number((value * 100) / (100 + taxPercentage));
        return amt;
    }

    const onInputBox_ChangeHandler = (e, row, columnName, isTaxAmountColumn, taxPercentage) => {           
        checkDecimalValue(e, row, columnName, isTaxAmountColumn, taxPercentage);
    }

    const onDropdown_ChangeHandler = (e, row) => {
        row.isShopOpen = e.target.value;
        row.remarksOptionValues = getRemarksFilterValue(row.isShopOpen)
        const rmksCode = row.remarksOptionValues.filter(x => x.codeValueCategory.toLowerCase() === e.target.value.toLowerCase() )
        row.remarksId = rmksCode[0].codeValueId;
        row.remarksCode = rmksCode[0].codeValue;
        const value = checkIsShopOpenStatusCorrect(row);
        if(!value)
        {  
            checkAreInValidValuesForShopOpenYes(row, "isShopOpen", false, false, true);
        }   
        props.setOverviewRevenueData(row.revenueId, row, "isShopOpen", false, 0);      
    }

    const onRemarksDropdown_ChangeHandler = (e, row) => {
        const rmksCode = row.remarksOptionValues.filter(x => x.codeValueId === +e.target.value)
        row.remarksId = rmksCode[0].codeValueId;
        row.remarksCode = rmksCode[0].codeValue;
        props.setOverviewRevenueData(row.revenueId, row, "remarksId", false, 0);
    }

    const withInputBoxFormatter = (row, columnName, isTaxAmountColumn, taxPercentage) => {       
        return (
            <div style={{width: "10vw"}}> 
                 <div>
                    {!checkIsEditable(row, "revenue") && <CustomOverlayTrigger placement="right"
                        tooltip={changeRequestTooltip("cr_pending", row.changeRequest && row.changeRequest.revenueCrNumber)}>
                        <div  style={{float: "right"}} className = "Lock-icon" /> 
                    </CustomOverlayTrigger>}
                </div>          
                <div style={{ display: "flex", float: "right"  }}>
                    {row.isEditable && checkIsEditable(row, "revenue") ? <NumberFormat
                        id={columnName + "_" + row.revenueId}
                        value={!isTaxAmountColumn ? row[columnName] : row.revenueWithTaxAmount[columnName]}
                        thousandSeparator={"."}
                        decimalSeparator={!isTaxAmountColumn ? false : ","}
                        allowNegative={false}
                        className={ getClassFromFieldValidMessage(row, columnName, isTaxAmountColumn, false)}
                        disabled={!row.isEditable}
                        onBlur={(ev) => onInputBox_ChangeHandler(ev, row, columnName, isTaxAmountColumn, taxPercentage)}
                    />            
                : <div style={{ float: "right", marginRight: "0.5vw" }}>{!isTaxAmountColumn ? row[columnName] : row.revenueWithTaxAmount[columnName]}
                </div>}</div>               
            </div>
        )
    }

    const getClassFromFieldValidMessage = (row, columnName, isTaxAmountColumn, isShopOpen) => {
        let classname = !isTaxAmountColumn ? (!isShopOpen ? "OverviewDetails-Soldticket-box" :
        "OverviewDetails-select-box"): "OverviewDetails-edit-box";
        
        let columnNameValue = isTaxAmountColumn ? row.revenueWithoutTaxAmount[columnName] :row[columnName];
        return  (!row[columnName + "_IsValid"] || isMoreThanMaxValue(columnNameValue) ||
     isInvalidDecimal(columnNameValue)) ? classname + " highlight-field" : classname;
    }

    const checkIsEditable = (row, type) => { 
        if(row.changeRequest && type)   
        {
            return ! ((type === "revenue") ? row.changeRequest.isRevenuePending : row.changeRequest.isIntakeBookPending);
        }    
        return undefined;     
    }
   
    const shopOpenFormatter = (row, extraData) => {
        return (<div>                     
                    <div> 
                        {row.isEditable && checkIsEditable(row, "revenue") ? 
                        <select value={row.isShopOpen} title={"Shop open selection"}
                            id={"isShopOpen_" + row.revenueId}
                            className={ getClassFromFieldValidMessage(row, "isShopOpen", false, true)}
                            onChange={(ev) => onDropdown_ChangeHandler(ev, row)} >
                            <option value="Yes" title={"Yes"}>{extraData && languageContext.labels['yes']}</option>
                            <option value="No" title={"No"}>{extraData && languageContext.labels['no']}</option>
                        </select> : <div style={{float:"left", marginLeft: "30%"}}>
                        {extraData && languageContext.labels[(row.isShopOpen).toLowerCase()]}</div>}
                    </div>
                    <div style={{ float: "right", marginRight: "20%"}}>
                        {!checkIsEditable(row, "revenue") &&<CustomOverlayTrigger placement="right"
                         tooltip={changeRequestTooltip("cr_pending", row.changeRequest && row.changeRequest.revenueCrNumber)}>
                            <div  style={{float:"left"}} className = "Lock-icon" /> 
                        </CustomOverlayTrigger>}
                    </div>
                </div>)
    }   

    const getRemarksFilterValue = (isShopOpen) =>{
        return props.remarksOptions.filter(x =>x.codeValueCategory === isShopOpen)
    }

    const getRemarksOptionsValues = (row, extraData) => {
        const options = row.remarksOptionValues;
        return options && options.map(item=>{
            return <option value={item.codeValueId}>{extraData && languageContext.labels[item.codeValue]}</option>
        })
    }

    const remarksTooltip = (remarksCode) => (
        <Tooltip>{languageContext && languageContext.labels[remarksCode]}</Tooltip>
    );

    const remarksDropdownFormatter = (row, extraData) => { 
        return (<div>
            <div  style={{float:"right", marginTop: "0.7vw"}}>
                {!checkIsEditable(row, "revenue") && <CustomOverlayTrigger placement="right" tooltip={changeRequestTooltip("cr_pending", row.changeRequest && row.changeRequest.revenueCrNumber)}>
                    <div style={{float: "right"}} className = "Lock-icon" /> 
                </CustomOverlayTrigger>}
            </div>
            <div style={{ display: "flex", marginLeft: "5%" }}>
                {row.isEditable && checkIsEditable(row, "revenue") ? <OverlayTrigger placement="right"
                 overlay={remarksTooltip(row.remarksCode)}>
                <div style={{ width: "90%" }}>
                <select value={row.remarksId}
                            title="Remarks"
                            className="Remarks-select-box"
                            onChange={(ev) => onRemarksDropdown_ChangeHandler(ev, row)}>
                    {getRemarksOptionsValues(row, extraData)}
                </select></div>
                </OverlayTrigger>
             : <div style={{float:"right", width: "10vw", marginTop: "0.5vw"}}>{extraData && languageContext.labels[(row.remarksCode).toLowerCase()]}</div>}</div>
            </div>
        )
    } 

    const handlerFilterOverlayTrigger = (column, colName, isDate, isNested, nestedObjectField, isTotalColumn, isDropdown, isRuleValue) => {
        return (<FilterOverlayTrigger column={column}
            colName={colName}
            isDate={isDate}
            isNested={isNested}
            nestedObjectField={nestedObjectField}
            isTotalColumn={isTotalColumn}
            filterData={filterData}
            data={data}
            columnFilterIndexes={columnFilterIndexes}
            columnFilterOptions={columnFilterOptions}
            setFilterData={setFilterData}
            setColumnFilterIndexes={setColumnFilterIndexes}
            setColumnFilterOptions={setColumnFilterOptions}
            handlerCheckDetailsFilterApplied={handlerCheckDetailsFilterApplied}
            isDropdown={isDropdown}
            isRuleValue={isRuleValue}
              />);
    }

    const setHeaderTabIndex = () => {
        let header = document.querySelectorAll(".OverviewDetails-datatable thead th");
        if (header && header.length > 0) {
            header.forEach(element => {
                element.setAttribute("tabindex", "-1");
            });
        }
    }

    const clearFilterStateData = ()=> {
        setFilterData([]);
        setColumnFilterIndexes([]);
        setColumnFilterOptions(new Map());
        handlerOnClearFilterClick(false);
    }

    useEffect(() => {
        setHeaderTabIndex();
    }, []);

    useEffect(() => {
        if(isClearFilter) {
            clearFilterStateData();
        }
    }, [isClearFilter]);

    function setRevenueTotalData(revenueAmountDetailsData, columnName, editableColumnName, 
                                isTaxAmountColumn, isWithTaxColumn, isTotalWithTaxColumn, 
                                filterDataValues) {
        revenueAmountDetailsData = isTaxAmountColumn ? 
                    {
                        ...revenueAmountDetailsData,
                        [columnName]: isWithTaxColumn ? getWithVatValueFooter(editableColumnName, filterDataValues)
                                                      : getWithoutVatValueFooter(editableColumnName, filterDataValues)
                    }
                    :   
                    {
                        ...revenueAmountDetailsData,
                        [columnName]: editableColumnName ? getTotalSoldTicketsValueFooter(filterDataValues) :
                                      getTotalFilterValueFooter(filterDataValues, columnName).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, ".")
                    }
        
        return revenueAmountDetailsData;
    }
    
    function getWithVatValueFooter(columnName, filterDataValues) {
        let total = null;
        columnName && filterDataValues.map(c => {
            let value = (c.revenueWithTaxAmount[columnName].replace(/\./g, "")).replace(/\,/g, ".");
            let withTax = value && value.trim() !== "" && Number(value);
            total = total + withTax
        });
    
        return total ? total.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, ".") : total;
    }
    
    function getWithoutVatValueFooter(columnName, filterDataValues) {
        let total = null;
        columnName && filterDataValues.map(c => {
            let value = (c.revenueWithoutTaxAmount[columnName].replace(/\./g, "")).replace(/\,/g, ".");
            let withoutTax = value && value.trim() !== "" && Number(value);
            total = total + withoutTax
        });
    
        return total ? total.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, ".") : total;
    }
    
    function getTotalSoldTicketsValueFooter(filterDataValues) {
        let total = null;
        filterDataValues.map(c => {
            let value = c.soldTicket.toLocaleString('nl-BE').replace(/\./g, "");
            let soldTicket = value && Number(value);
            total = total + soldTicket
        });
    
        return total ? total.toLocaleString('nl-BE').replace(/\s/g, ".") : total;
    }
    
    function getTotalFilterValueFooter(filterDataValues, totalColumnName) {
        let total = null;
        filterDataValues.map(c => {
            let value = (c[totalColumnName].toLocaleString('nl-BE').replace(/\./g, "")).replace(/\,/g, ".");
            let totalWithTax = value && Number(value);
            total = total + totalWithTax
        });
        return total
    }

    const sortStringHandler = (a, b, order, rowA, rowB, isRemarks) => {
        let aValue = a.toString().trim();
        let bValue = b.toString().trim();
        if(isRemarks && rowA && rowB)
        {  
            const aRmksCode = rowA.remarksOptionValues.filter(x => x.codeValueId === +a); 
            const bRmksCode = rowB.remarksOptionValues.filter(x => x.codeValueId === +b);  
            aValue = languageContext.labels[aRmksCode[0].codeValue.toLowerCase()];
            bValue = languageContext.labels[bRmksCode[0].codeValue.toLowerCase()];   
        }  
        return sortValue(aValue, bValue, order); 
    }   

    const sortDateHandler = (a, b, order) => {
        let aValue = parse(a, "dd/MM/yyyy", new Date());
        let bValue = parse(b, "dd/MM/yyyy", new Date());
        return sortValue(aValue, bValue, order);
    }

    const convertToNumber = (value) => {
        return Number(value.replace(/\./g, "").replace(/\,/g, "."))
    }

    const sortNumberHandler = (a, b, order) => {
        let aValue = convertToNumber(a);
        let bValue = convertToNumber(b);
        return sortValue(aValue, bValue, order);  
    } 

    const sortValue = (aValue, bValue, order) => { 
        if (order === 'desc') {
            return bValue > aValue ? 1 : bValue < aValue ? -1 : 0
        }                 
            return aValue > bValue ? 1 : aValue < bValue ? -1 : 0   
    }  
      

    const columns = [
        {
            dataField: 'businessPartnerName',
            text:  <span className="column-header-text" ><LabelText tid="businesspartner_payername" /></span>,
            styles: "businessPartnerName",
            footer: "",
            headerClasses: "businessPartnerName-header",
            editable: false,
            columnIndex: 0,
            onSort: () => setSortOrder(undefined),
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "businessPartnerName", false, false, null, false, false, false),
            footerClasses: "transperent-border",           
            sort: true, 
            sortCaret : (order, column) => sortHandler(order, column, false), 
            sortFunc: (a, b, order, dataField, rowA, rowB) => sortStringHandler(a, b, order, rowA, rowB, false),       
        },
        {
            dataField: 'concessionName',
            text:  <span className="column-header-text" ><LabelText tid="concessionname" /></span>,
            columnIndex: 1,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "concessionName", false, false, null, false, false, false),
            editable: false,
            sort: true,
            headerClasses: "concessionName-header",
            sortCaret : (order, column) => sortHandler(order, column, false),
            onSort: () => setSortOrder(undefined),
            sortFunc: (a, b, order, dataField, rowA, rowB) => sortStringHandler(a, b, order, rowA, rowB, false),
            footerClasses: "transperent-border",  
            footer: "",  
        },
        {
            dataField: 'stationName',
            sort: true, 
            text:  <span className="column-header-text" ><LabelText tid="station" /></span>,           
            editable: false,
            columnIndex: 2,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "stationName", false, false, null, false, false, false),
            headerClasses: "station-header",
            footerClasses: "transperent-border",
            onSort: () => setSortOrder(undefined),
            footer: "",
            sortCaret : (order, column) => sortHandler(order, column, false),  
            sortFunc: (a, b, order, dataField, rowA, rowB) => sortStringHandler(a, b, order, rowA, rowB, false),   
        },
        {
            sort: true, 
            sortFunc: (a, b, order, dataField, rowA, rowB) => sortStringHandler(a, b, order, rowA, rowB, false),
            footer: "",
            dataField: 'contractCode',
            columnIndex: 3,
            filter: customFilter(),
            onSort: () => setSortOrder(undefined),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "contractCode", false, false, null, false, false, false),
            text:  <span className="column-header-text" ><LabelText tid="contractcode" /></span>,
            editable: false,
            headerClasses: "contractCode-header",
            footerClasses: "transperent-border",                        
            sortCaret : (order, column) => sortHandler(order, column, false),    
        },
        {
            dataField: 'revenueDate',
            text:  <span className="column-header-text" ><LabelText tid="Day" /></span>,
            sort: true, 
            sortFunc: (a, b, order) => sortDateHandler(a, b, order),
            onSort: () => setSortOrder(undefined),
            columnIndex: 4,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "revenueDate", true, true, null, false, false, false),
            editable: false,
            headerClasses: "day-header",
            footerClasses: "total-footer-label footer-value",
            footer: languageContext && languageContext.labels['Total'],            
            sortCaret : (order, column) => sortHandler(order, column, false),    
        },
        {
            dataField: 'revenueWithoutTaxAmount.tax_0',
            text:  <span className="column-header-text" ><LabelText tid="WithoutVAT_0" /></span>,
            editable: false,
            align: 'right',
            headerClasses: "woTax-header",
            sort: true, 
            sortCaret : (order, column) => sortHandler(order, column, false), 
            footer: "",
            footerAlign: 'right',
            footerClasses: "footer-value",
            columnIndex: 5,
            onSort: () => setSortOrder(undefined),
            filter: customFilter(),
            sortFunc: (a, b, order) => sortNumberHandler(a, b, order),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "tax_0", false, true, "revenueWithoutTaxAmount", false, false, false),
            footerFormatter: (cell, row, rowIndex) => {
                return getRevenueAmtField(row, "withoutVatTax_0", true, "tax_0", false, false);
            },
        },
        {
            dataField: 'revenueWithoutTaxAmount.tax_6',
            editable: false,
            align: 'right',
            headerClasses: "woTax-header",
            footer: "",
            sort: true, 
            footerClasses: "footer-value",
            sortFunc: (a, b, order) => sortNumberHandler(a, b, order),
            text:  <span className="column-header-text" ><LabelText tid="WithoutVAT_6" /></span>,
            footerAlign: 'right',
            columnIndex: 6,
            filter: customFilter(),
            onSort: () => setSortOrder(undefined),
            footerFormatter: (cell, row, rowIndex) => {
                return getRevenueAmtField(row, "withoutVatTax_6", true, "tax_6", false, false);
            },
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "tax_6", false, true, "revenueWithoutTaxAmount", false, false, false),
            sortCaret : (order, column) =>sortHandler(order, column, false),     
        },
        {
            dataField: 'revenueWithoutTaxAmount.tax_12',
            editable: false,
            sortFunc: (a, b, order) => sortNumberHandler(a, b, order),
            align: 'right',
            text:  <span className="column-header-text" ><LabelText tid="WithoutVAT_12" /></span>,
            headerClasses: "woTax-header",
            footer: "",
            footerClasses: "footer-value",
            sort: true, 
            onSort: () => setSortOrder(undefined),
            footerAlign: 'right',
            footerFormatter: (cell, row, rowIndex) => {
                return getRevenueAmtField(row, "withoutVatTax_12", true, "tax_12", false, false);
            },
            columnIndex: 7,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "tax_12", false, true, "revenueWithoutTaxAmount", false, false, false),
            sortCaret : (order, column) =>sortHandler(order, column, false),   
        },
        {
            dataField: 'revenueWithoutTaxAmount.tax_21',
            align: 'right',
            text:  <span className="column-header-text" ><LabelText tid="WithoutVAT_21" /></span>,
            editable: false,
            onSort: () => setSortOrder(undefined),
            footerFormatter: (cell, row, rowIndex) => {
                return getRevenueAmtField(row, "withoutVatTax_21", true, "tax_21", false, false);
            },
            sortCaret : (order, column) => sortHandler(order, column, false),
            headerClasses: "woTax-header",
            footer: "",
            footerClasses: "footer-value",
            footerAlign: 'right',
            sortFunc: (a, b, order) => sortNumberHandler(a, b, order),
            sort: true, 
            columnIndex: 8,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "tax_21", false, true, "revenueWithoutTaxAmount", false, false, false),
        },
        {
            dataField: 'totalValueWithoutVat',
            align: 'right',
            footerAlign: 'right',  
            headerClasses: "woTOTAL-header",
            footer: "",
            text:  <span className="column-header-text" ><LabelText tid="TotalValueWithoutVAT" /></span>,
            editable: false,
            footerClasses: "footer-value",                      
            sort: true,  
            onSort: () => setSortOrder(undefined),
            sortFunc: (a, b, order) => sortNumberHandler(a, b, order),
            sortCaret : (order, column) => sortHandler(order, column, false), 
            columnIndex: 9,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "totalValueWithoutVat", false, false, null, true, false, false),
            footerFormatter: (cell, row, rowIndex) => {
                return getRevenueAmtField(row, "totalValueWithoutVat", false, null, false, false);
            }, 
        },
        {
            dataField: 'revenueWithTaxAmount.tax_0',           
            footer: "",
            align: 'right',
            columnIndex: 10,
            sortFunc: (a, b, order) => sortNumberHandler(a, b, order),
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "tax_0", false, true, "revenueWithTaxAmount", false, false, false),
            footerFormatter: (cell, row, rowIndex) => {
                return getRevenueAmtField(row, "withVatTax_0", true, "tax_0", true, false);
            },
            headerFormatter: (cell, colIndex, {sortElement, filterElement}) => headerFormatterHandler(cell, false, "WithVAT_0", filterElement),
            formatter: (cell, row, rowIndex) => withInputBoxFormatter(row, "tax_0", true, 0),
            onSort: (field, order) => {
                setSortOrder(order + "," + field)
            },
            sort: true, 
            footerClasses: "footer-value-edit-column",
            footerAlign: 'right',
            editable: false,
         },
        {
            dataField: 'revenueWithTaxAmount.tax_6',
            editable: false,
            align: 'right',          
            footerAlign: 'right',
            sortFunc: (a, b, order) => sortNumberHandler(a, b, order),
            onSort: (field, order) => {
                setSortOrder(order+","+field)
            },
            footer: "",
            footerClasses: "footer-value-edit-column",
            headerFormatter: (cell, colIndex, {sortElement, filterElement}) => headerFormatterHandler(cell, false, "WithVAT_6", filterElement),
            formatter: (cell, row, rowIndex) => withInputBoxFormatter(row, "tax_6", true, 6),
            columnIndex: 11,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "tax_6", false, true, "revenueWithTaxAmount", false, false, false),
            footerFormatter: (cell, row, rowIndex) => {
                return getRevenueAmtField(row, "withVatTax_6", true, "tax_6", true, false);
            },
            sort: true,            
        },
        {
            dataField: 'revenueWithTaxAmount.tax_12',
            align: 'right',
            footer: "",
            editable: false,
            footerClasses: "footer-value-edit-column",
            footerAlign: 'right',
            sortFunc: (a, b, order) => sortNumberHandler(a, b, order),
            headerFormatter: (cell, colIndex, {sortElement, filterElement}) => headerFormatterHandler(cell, false, "WithVAT_12", filterElement),
            formatter: (cell, row, rowIndex) => withInputBoxFormatter(row, "tax_12", true, 12),
            onSort: (field, order) => {
                setSortOrder(order + "," + field)
            } ,
            columnIndex: 12,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "tax_12", false, true, "revenueWithTaxAmount", false, false, false),
            footerFormatter: (cell, row, rowIndex) => {
                return getRevenueAmtField(row, "withVatTax_12", true, "tax_12", true, false);
            },
            sort: true,  
        },            
        {
            dataField: 'revenueWithTaxAmount.tax_21',
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "tax_21", false, true, "revenueWithTaxAmount", false, false, false),
            footerFormatter: (cell, row, rowIndex) => {
                return getRevenueAmtField(row, "withVatTax_21", true, "tax_21", true, false);
            },
            editable: false,
            align: 'right',
            footer: "",
            footerClasses: "footer-value-edit-column",
            footerAlign: 'right',
            headerFormatter: (cell, colIndex, {sortElement, filterElement}) => headerFormatterHandler(cell, false, "WithVAT_21", filterElement),
            onSort: (field, order) => {
                setSortOrder(order + "," + field)
            } ,
            formatter: (cell, row, rowIndex) => withInputBoxFormatter(row, "tax_21", true, 21),
            columnIndex: 13,
            filter: customFilter(),
            sort: true,
            sortFunc: (a, b, order) => sortNumberHandler(a, b, order),
        },
        {
            dataField: 'totalValueWithVat',
            text:  <span className="column-header-text" ><LabelText tid="TotalValueWithVAT" /></span>,
            editable: false,
            align: 'right',
            columnIndex: 14,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "totalValueWithVat", false, false, null, true, false, false),
            footerFormatter: (cell, row, rowIndex) => {
                return getRevenueAmtField(row, "totalValueWithVat", false, null, false, true);
            }, 
            sort: true,  
            onSort: () => setSortOrder(undefined),
            sortCaret : (order, column) => sortHandler(order, column, false), 
            headerClasses: "totalValue-header",
            footer: "",
            footerClasses: "footer-value",
            footerAlign: 'right',  
            sortFunc: (a, b, order) => sortNumberHandler(a, b, order),
        },
        {            
            headerClasses: "soldtickets-header",
            footerClasses: "footer-value-edit-column",
            footer: "",
            onSort: (field, order) => {
                setSortOrder(order+","+field)
            },
            footerAlign: 'right',
            headerFormatter: (cell, colIndex, {sortElement, filterElement}) => headerFormatterHandler(cell, false, "Sold_Ticket", filterElement),
            formatter: (cell, row, rowIndex) => withInputBoxFormatter(row, "soldTicket", false, 0),
            columnIndex: 15,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "soldTicket", false, true, null, true, false, false),
            footerFormatter: (cell, row, rowIndex) => {
                return getRevenueAmtField(row, "totalSoldTickets", false, "totalSoldTickets", false, false);
            }, 
            sort: true, 
            dataField: 'soldTicket',
            editable: false,
            align: 'right',  
            sortFunc: (a, b, order) => sortNumberHandler(a, b, order),          
        },
        {
            dataField: 'revenueSubmittedDate',
            text:  <span className="column-header-text" ><LabelText tid="submitteddate" /></span>,
            editable: false,
            classes: 'submittedDate-tb',
            headerClasses: "submittedDate-header",
            footerClasses: "transperent-border",           
            footer: "",
            columnIndex: 16,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "revenueSubmittedDate", true, true, null, false, false, false),
            sort: true,  
            onSort: () => setSortOrder(undefined),
            sortCaret : (order, column) => sortHandler(order, column, false),   
            sortFunc: (a, b, order) => sortDateHandler(a, b, order),
        },
        {
            dataField: 'revenueSubmittedTime',           
            text:  <span className="column-header-text" ><LabelText tid="submittedtime" /></span>,
            editable: false,
            classes: 'submittedDate-tb',
            headerClasses: "submittedDate-header",
            footerClasses: "transperent-border",
            footer: "",
            onSort: () => setSortOrder(undefined),
            columnIndex: 17,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "revenueSubmittedTime", true, false, null, false, false, false),
            sort: true,  
            sortCaret : (order, column) => sortHandler(order, column, false), 
            sortFunc: (a, b, order) => {
                if (order === 'desc') {
                    return b.localeCompare(a);
                }     
                return a.localeCompare(b); 
            }  
        },
        {
            dataField: 'isShopOpen',
            editable: false,
            onSort: (field, order) => {
                setSortOrder(order+","+field)
            } ,
            headerClasses: "shopOpen-header",
            footer: "",
            headerFormatter: (cell, colIndex, {sortElement, filterElement}) => headerFormatterHandler(cell, false, "Shop_Open", filterElement),
            formatter: (cell, row, rowIndex, extraData) => shopOpenFormatter(row, extraData),
            formatExtraData: languageContext && languageContext.language.id,
            footerClasses: "transperent-border",
            sort: true,  
            columnIndex: 18,
            filter: customFilter(),
            sortFunc: (a, b, order, dataField, rowA, rowB) => sortStringHandler(a, b, order, rowA, rowB, false),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "isShopOpen", false, false, null, false, true, false),
        },
        {
            dataField: 'remarksId',
            editable: false,
            onSort: (field, order) => {
                setSortOrder(order+","+field)
            } ,
            headerClasses: "Remarks-header",
            footer: "",
            align: 'left',
            headerFormatter: (cell, colIndex, {sortElement, filterElement}) => headerFormatterHandler(cell, false, "remarks", filterElement),
            formatter: (cell, row, rowIndex, extraData) => remarksDropdownFormatter(row, extraData),
            formatExtraData: languageContext && languageContext.language.id,
            footerClasses: "transperent-border",
            sort: true,  
            columnIndex: 19,
            filter: customFilter(),
            sortFunc: (a, b, order, dataField, rowA, rowB) => sortStringHandler(a, b, order, rowA, rowB, true),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "remarksCode", false, false, null, false, true, false),
        },
        {
            dataField: 'userCashRegisterFileName',
            editable: false,
            headerClasses: "cashRegister-header",
            footer: "",
            headerFormatter: (cell, row, rowIndex) => headerFormatterHandler(cell, true, "CashRegister"),
            formatter: (cell, row, rowIndex) => {
                return (                   
                    row.userCashRegisterFileName && <a href='#'
                     title={"Download cash register link"} className ="cash-register-download-link"
                    onClick={()=>props.DownloadCashRegister(row.contractCode, row.revenueDate, row.userCashRegisterFileName)}
                    ><LabelText tid="Link" /></a>
                )
            },
            footerClasses: "transperent-border", 
        },
        {
            dataField: 'isFileUploaded',
            editable: false,
            hidden: !props.isEditAccess,
            headerFormatter: (cell, row, rowIndex) => headerFormatterHandler(cell, true, "Upload_Cash_Register"),
            formatExtraData: props.cashRegisterMandatory,
            formatter: (cell, row, rowIndex, extraData) => {
                return (
                    <>
                     {!checkIsEditable(row, "intakebook") && <div>
                    <CustomOverlayTrigger placement="right" tooltip={changeRequestTooltip("cr_pending",
                     row.changeRequest && row.changeRequest.intakeBookCrNumber)}>
                        <div  style={{float: "right", marginTop : "1vw", marginRight: "2vw"}} className = "Lock-icon" /> 
                    </CustomOverlayTrigger>
                    </div>}
                    <div role="button" title={"Upload cash register button"} tabIndex="0" 
                        disabled={!(row.isEditable && row.isMonthlyRevenueSubmitted && checkIsEditable(row, "intakebook")) }
                        onClick={()=>row.isEditable && row.isMonthlyRevenueSubmitted && checkIsEditable(row, "intakebook") ? props.handlerOnCashRegisterIconClick(row.revenueId, row): undefined}
                        onKeyDown={(e)=> { if(row.isEditable && row.isMonthlyRevenueSubmitted && checkIsEditable(row, "intakebook") && e.key === "Enter") { props.handlerOnCashRegisterIconClick(row.revenueId, row) }}}
                        style={{float:"right", marginRight : checkIsEditable(row, "intakebook") ? "5vw" : "1vw"}}>
                        <FontAwesomeIcon className={(row.isEditable && row.isMonthlyRevenueSubmitted && checkIsEditable(row, "intakebook")) ? extraData && props.cashRegisterMandatory && isNullOrUndefined(row.userCashRegisterFileName) ?
                         "fa-cash-register File-notuploaded highlight-field" : "fa-cash-register File-notuploaded": "fa-cash-register File-submitted"}
                        icon= {faReceipt} />
                    </div>
                    </>
                )
            },
            footer: "",
            footerClasses: "transperent-border",  
        },
        {
            dataField: 'businessPartnerCode',
            text: <span className="column-header-text" ><LabelText tid="businesspartnercode" /></span>,
            editable: false,
            headerClasses: "businessPartnerCode-header",
            footer: "",
            footerClasses: "transperent-border",            
            sort: true,  
            sortCaret : (order, column) => sortHandler(order, column, false),   
            columnIndex: 22,
            filter: customFilter(),
            onSort: () => setSortOrder(undefined),
            sortFunc: (a, b, order, dataField, rowA, rowB) => sortStringHandler(a, b, order, rowA, rowB, false),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, 
                "businessPartnerCode", false, false, null, false, false, false),
        },
        {
            dataField: 'billingRule',
            text: <span className="column-header-text" ><LabelText tid="billing_rule" /></span>,
            editable: false,
            headerClasses: "businessPartnerCode-header",
            footer: "",
            footerClasses: "transperent-border",            
            sort: true,  
            sortCaret : (order, column) => sortHandler(order, column, false),   
            columnIndex: 23,
            filter: customFilter(),
            formatter: (cell, row, rowIndex) => {
                return getFormattedRuleData(row, "billingRule");
            },
            onSort: () => setSortOrder(undefined),
            sortFunc: (a, b, order, dataField, rowA, rowB)  =>  sortStringHandler(a, b, order, rowA, rowB, false),
            filterRenderer: (onFilter, column)  =>   handlerFilterOverlayTrigger(column, "billingRule", false, 
                                                     false, null, false, false, true)
        },
        {
            dataField: 'conditionRule',
            headerClasses: "businessPartnerCode-header",
            text: <span className="column-header-text" ><LabelText tid="condition_rule" /></span>,
            footer: "",
            footerClasses: "transperent-border", 
            editable: false,
            columnIndex: 24,
            sort: true,  
            sortCaret : (order, column) => sortHandler(order, column, false),   
            filter: customFilter(),
            formatter: (cell, row, rowIndex) => {
                return getFormattedRuleData(row, "conditionRule");
            },
            onSort: () => setSortOrder(undefined),
            sortFunc: (a, b, order, dataField, rowA, rowB) =>  
                                                    sortStringHandler(a, b, order, rowA, rowB, false),
            filterRenderer: (onFilter, column)  =>   handlerFilterOverlayTrigger(column, "conditionRule", false, 
                                                    false, null, false, false, true)
        }
    ];

    const tableRowStyle = (row, rowIndex) => {
        const style = {};
        style.lineHeight = "7vh";
        if (rowIndex % 2 === 0)
            style.backgroundColor = '#ffffff';
        else
            style.backgroundColor = '#eff4f9';

        return style;
    }

    return (
        
            
        <div className="OverviewDetails-main">
            <Container>  
            <Row>
            <BootstrapTable
                keyField='nmbsUserDetailOverviewDtos.contractId'
                data={filterData && filterData.length > 0 ? filterData :  data}
                filter={ filterFactory() }
                columns={columns}
                bordered
                rowStyle={tableRowStyle}
                classes={"OverviewDetails-datatable scroller"}
                headerClasses={"OverviewDetails-datatable-header"}
                footerClasses={`OverviewDetails-datatable-footer ${data && data.length % 2 === 0 ?
                     `footer-Odd-Backgroundcolor` : `footer-Even-Backgroundcolor`}`}
            />
            </Row>
            {                
                <Row><div style={{ width: '100%' }}>
                    <OverviewDetailFooter/>
                    </div>
                </Row>                    
            }
            {                
                <Row><div style={{ width: '100%' }}>
                    <div className="Error-container-footer">
                        {error && error.trim() !== "" ?
                        <>
                        <div className = "Error-icon">                            
                        </div>
                        <div className="Errormsg">
                            <LabelText tid={error} />
                        </div>
                        </>: undefined}
                        </div>
                        </div> 
                </Row>                    
            }</Container>
        </div>
    );
}